import type { StaticImageData } from 'next/image'

// Import logos
import nvdaLogo from './nvda-logo.png'
import aaplLogo from './aapl-logo.png'
import msftLogo from './msft-logo.png'
import googlLogo from './googl-logo.png'
import amznLogo from './amzn-logo.png'
import avgoLogo from './avgo-logo.png'
import metaLogo from './meta-logo.png'
import tslaLogo from './tsla-logo.png'
import tsmLogo from './tsm-logo.png'
import brkaLogo from './brka-logo.png'
import llyLogo from './lly-logo.png'
import jpmLogo from './jpm-logo.png'
import wmtLogo from './wmt-logo.png'
import orclLogo from './orcl-logo.png'
import vLogo from './v-logo.png'
import xomLogo from './xom-logo.png'
import maLogo from './ma-logo.png'
import jnjLogo from './jnj-logo.png'
import pltrLogo from './pltr-logo.png'
import nflxLogo from './nflx-logo.png'

type CompanySymbol =
    | 'NVDA'
    | 'AAPL'
    | 'MSFT'
    | 'GOOGL'
    | 'AMZN'
    | 'AVGO'
    | 'META'
    | 'TSLA'
    | 'TSM'
    | 'BRK.A'
    | 'LLY'
    | 'JPM'
    | 'WMT'
    | 'ORCL'
    | 'V'
    | 'XOM'
    | 'MA'
    | 'JNJ'
    | 'PLTR'
    | 'NFLX'

export const COMPANY_LOGOS_ARRAY: Array<{ symbol: CompanySymbol; logo: StaticImageData }> = [
    { symbol: 'NVDA', logo: nvdaLogo },
    { symbol: 'AAPL', logo: aaplLogo },
    { symbol: 'MSFT', logo: msftLogo },
    { symbol: 'GOOGL', logo: googlLogo },
    { symbol: 'AMZN', logo: amznLogo },
    { symbol: 'AVGO', logo: avgoLogo },
    { symbol: 'META', logo: metaLogo },
    { symbol: 'TSLA', logo: tslaLogo },
    { symbol: 'TSM', logo: tsmLogo },
    { symbol: 'BRK.A', logo: brkaLogo },
    { symbol: 'LLY', logo: llyLogo },
    { symbol: 'JPM', logo: jpmLogo },
    { symbol: 'WMT', logo: wmtLogo },
    { symbol: 'ORCL', logo: orclLogo },
    { symbol: 'V', logo: vLogo },
    { symbol: 'XOM', logo: xomLogo },
    { symbol: 'MA', logo: maLogo },
    { symbol: 'JNJ', logo: jnjLogo },
    { symbol: 'PLTR', logo: pltrLogo },
    { symbol: 'NFLX', logo: nflxLogo },
]
